module.exports = __webpack_public_path__ + "static/media/top-artists.dc046b31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top-artists.jpg
// module id = 81
// module chunks = 0